import {
  DrawerBackdrop,
  DrawerBody,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerFooter,
  DrawerRoot,
  DrawerTitle,
  DrawerTrigger,
} from "../ui/drawer"
import { colors } from "../../utilities/colors"

export default function ReusableDrawer({
  isOpen,
  bgColor,
  size = 'xs',
  height,
  zIndex,
  titleStyle,
  onClose,
  title,
  bodyContent,
  bodyStyle,
  footerStyle,
  footerContent,
  placement,
  renderTrigger = true,
  children
}) {
  const handleCancel = () => {
    onClose()
  }
  const heightProps = height !== undefined ? { h: height } : {}
  const zIndexProps = zIndex !== undefined ? { zIndex } : {}
  return (
    <DrawerRoot open={isOpen} placement={placement} onOpenChange={handleCancel} size={size}>
      <DrawerBackdrop {...zIndexProps} />
      {renderTrigger && <DrawerTrigger />}
      <DrawerContent bg={bgColor ?? colors.grey900} {...heightProps} {...zIndexProps}>
        <DrawerCloseTrigger />
        <DrawerTitle
          p={4}
          textStyle='xl'
          className={titleStyle}
        >
          {title}
        </DrawerTitle>
        <DrawerBody className={bodyStyle}>
          {children}
          {bodyContent}
        </DrawerBody>
        <DrawerFooter className={footerStyle}>
          {footerContent}
        </DrawerFooter>
      </DrawerContent>
    </DrawerRoot>
  )
}